const MAX_ADDRESS_EXTRA_LENGTH = 100

function normalizeAddressExtra(extra) {
    if(extra == null) return null

    const value = String(extra).trim()

    return value === '' ? null : value
}

function validateAddressExtra(extra) {
    const value = normalizeAddressExtra(extra)

    if(value && value.length > MAX_ADDRESS_EXTRA_LENGTH) {
        return {
            valid: false,
            value,
            message: `Extra must be ${MAX_ADDRESS_EXTRA_LENGTH} characters or less`
        }
    }

    return {
        valid: true,
        value,
        message: ''
    }
}

function sqlValue(value) {
    if(value == null) return 'null'

    return `'${String(value).replace(/'/g, "''")}'`
}

module.exports = {
    MAX_ADDRESS_EXTRA_LENGTH,
    normalizeAddressExtra,
    validateAddressExtra,
    sqlValue
}
